/**
 * Shortcut for DOM querying (single result)
 *
 * @param {String} selector - the CSS selector(s) to search for
 * @param {Element} scope - the element to search within (default: document)
 * @return {Element|null} - the first matching element, or null if there is no match.
 */
const qs = (selector, scope = document) => scope.querySelector(selector);

/**
 * Shortcut for DOM querying (multiple results)
 *
 * @param {String} selector - the CSS selector(s) to search for
 * @param {Element} scope - the element to search within (default: document)
 * @return {Array<Element>} - array of matching elements, empty if there are no matches.
 */
const qsa = (selector, scope = document) => scope.querySelectorAll(selector);

/**
 * @summary Look up a <meta> tag by name and get its content.
 * This method is copied from VHL.Common.
 *
 * @param {String} name - the value of the tag's `name` attribute
 * @return {String} the value of the tag's `content` attribute
 */
const metaTagContent = (name) => {
  const tagElm = document.querySelector(`meta[name="${name}"]`);

  // If the meta doesn't exist, return a sensible default.
  if (tagElm === null) {
    return undefined;
  }

  return tagElm.getAttribute('content');
};

export {
  metaTagContent,
  qs,
  qsa,
};
